import React, { useEffect, useRef, useState } from 'react';
import * as styles from '../css/feedback-carousel.css';
import FeedbackContent from '../containers/FeedbackContent';
import FeedbackCarouselItem from '../containers/FeedbackCarouselItem';
import FeedbackCarouselContainer from '../containers/FeedbackCarouselContainer';

interface Props {
    items: string[];
}

const FeedbackCarousel = ({ items }: Props) => {
    const carouselContainerRef = useRef<HTMLDivElement>(null);
    const desktopLayoutMeasurementRef = useRef<HTMLDivElement>(null);
    const [fitsThree, setFitsThree] = useState(true);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            const availableWidth = carouselContainerRef.current!.clientWidth;
            const requiredWidth = desktopLayoutMeasurementRef.current!.scrollWidth;

            setFitsThree(availableWidth >= requiredWidth);
        });

        observer.observe(carouselContainerRef.current!);

        return () => {
            observer.disconnect();
        };
    }, []);

    const desktopLayoutContentMeasurement = (
        <div ref={desktopLayoutMeasurementRef} className={styles.desktopLayoutMeasurement}>
            <FeedbackCarouselContainer>
                <FeedbackCarouselItem>
                    {[1, 2, 3].map(item => (
                        <FeedbackContent key={item}>
                            {item}
                        </FeedbackContent>
                    ))}
                </FeedbackCarouselItem>
            </FeedbackCarouselContainer>
        </div>
    );

    return (
        <div ref={carouselContainerRef}>
            <FeedbackCarouselContainer>
                {groupItems(items, fitsThree ? 3 : 1).map((group, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <FeedbackCarouselItem key={index}>
                        {group.map((item, i) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <FeedbackContent key={i}>
                                {item}
                            </FeedbackContent>
                        ))}
                    </FeedbackCarouselItem>
                ))}
            </FeedbackCarouselContainer>
            {desktopLayoutContentMeasurement}
        </div>
    );
};

function groupItems<T>(items: T[], size: number): T[][] {
    return items.reduce<T[][]>((acc, item, index) => {
        const groupIndex = Math.floor(index / size);

        if (!acc[groupIndex]) {
            acc[groupIndex] = [];
        }
        acc[groupIndex].push(item);

        return acc;
    }, []);
}

export default FeedbackCarousel;
